import axios from 'axios';
import {useInfiniteQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const factors = async (data: FactorsReqT) => {
  const {pageParam, quickFilters} = data;

  const qs = `?page=${pageParam ?? 1}${quickFilters ? '&' + quickFilters : ''}`;

  return axios.get(Routes.FACTORS + qs);
};

export const useFactors = (params: FactorsReqT) => {
  const {quickFilters} = params;

  return useInfiniteQuery({
    queryKey: [Keys.FACTORS_QRY, quickFilters],
    queryFn: ({pageParam = 1}) => factors({pageParam, ...params}),
    getNextPageParam: lastPage => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: firstPage => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
